module.exports = __webpack_public_path__ + "img/sld_inverter_green_b1_dark.4e3c7739.svg";